import { Box, Loader, Text } from '@hopskipdrive/react-components';

import { useLoader } from '../../contexts/LoaderContext';

import { StyledBackdrop } from './PageLoader.styles';

export const PageLoader: React.FC = () => {
  const { loading, message } = useLoader();

  return (
    <StyledBackdrop open={loading} transitionDuration={{ appear: 500, enter: 200, exit: 500 }}>
      <Box display="flex" flexDirection="column" alignItems="center" gap="16px">
        <Text textColor="primary" variant="h1">
          {message}
        </Text>
        <Loader />
      </Box>
    </StyledBackdrop>
  );
};
